import { TrendingUpIcon, TrendingDownIcon, InfoIcon } from 'lucide-react';
import { StatCardData } from '../../types';

const StatCard = ({ title, value, trend, change, isPositive }: StatCardData) => {
  const TrendIcon = isPositive ? TrendingUpIcon : TrendingDownIcon;
  const colorClass = isPositive ? 'text-green-600 bg-green-50' : 'text-red-600 bg-red-50';
  
  return (
    <article className="bg-white rounded-lg p-4 border border-gray-200" aria-label={`${title}: ${value}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm text-gray-600">{title}</span>
        <InfoIcon className="w-4 h-4 text-gray-400" aria-label="More information" />
      </div>
      <div className="flex items-end justify-between">
        <span className="text-3xl font-semibold text-gray-900">{value}</span>
        <div className={`flex items-center gap-1 text-sm ${colorClass} px-2 py-1 rounded`}>
          <TrendIcon className="w-4 h-4" />
          <span>{trend}</span>
          {change && <span className="text-xs opacity-75">({change})</span>}
        </div>
      </div>
    </article>
  );
};

export default StatCard;
